import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Table, Collapse } from "react-bootstrap";
import { db, storage } from "../FireBase";
import {
  collection,
  addDoc,
  getDocs,
  updateDoc,
  deleteDoc,
  doc,
  query,
  where,
} from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";

const SchemeCategoryModal = ({ show, handleClose }) => {
  const [categories, setCategories] = useState([]);
  const [schemes, setSchemes] = useState([]);
  const [categoryData, setCategoryData] = useState({
    name: "",
    image: null,
    status: true,
  });
  const [preview, setPreview] = useState("");
  const [loading, setLoading] = useState(false);
  const [editId, setEditId] = useState(null);
  const [openCategory, setOpenCategory] = useState(null);

  // Fetch categories
  const fetchCategories = async () => {
    const querySnapshot = await getDocs(collection(db, "scheme_categories"));
    const data = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    setCategories(data);
  };

  // Fetch schemes
  const fetchSchemes = async () => {
    const querySnapshot = await getDocs(collection(db, "schemes"));
    const data = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    setSchemes(data);
  };

  useEffect(() => {
    fetchCategories();
    fetchSchemes();
  }, []);

  // Handle image preview
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setCategoryData({ ...categoryData, image: file });
    setPreview(URL.createObjectURL(file));
  };

  // Add or Update
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      let imageUrl = "";
      if (categoryData.image && typeof categoryData.image !== "string") {
        const imageRef = ref(
          storage,
          `scheme_categories/${Date.now()}_${categoryData.image.name}`
        );
        await uploadBytes(imageRef, categoryData.image);
        imageUrl = await getDownloadURL(imageRef);
      } else if (typeof categoryData.image === "string") {
        imageUrl = categoryData.image;
      }

      if (editId) {
        await updateDoc(doc(db, "scheme_categories", editId), {
          name: categoryData.name,
          image: imageUrl,
        });
      } else {
        await addDoc(collection(db, "scheme_categories"), {
          name: categoryData.name,
          image: imageUrl,
          status: true,
          createdAt: new Date(),
        });
      }

      await fetchCategories();
      setCategoryData({ name: "", image: null, status: true });
      setPreview("");
      setEditId(null);
      handleClose();
    } catch (error) {
      console.error("Error saving category:", error);
    } finally {
      setLoading(false);
    }
  };

  // Edit
  const handleEdit = (cat) => {
    setCategoryData({
      name: cat.name,
      image: cat.image,
      status: cat.status,
    });
    setPreview(cat.image);
    setEditId(cat.id);
  };

  // Delete
  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this category?")) {
      await deleteDoc(doc(db, "scheme_categories", id));
      fetchCategories();
    }
  };

  // Toggle active/inactive
  const handleStatusToggle = async (id, currentStatus) => {
    await updateDoc(doc(db, "scheme_categories", id), {
      status: !currentStatus,
    });
    fetchCategories();
  };

  // Get schemes by category
  const getSchemesByCategory = (categoryId) =>
    schemes.filter((scheme) => scheme.categoryId === categoryId);

  return (
    <>
      {/* Modal for Add/Edit */}
      <Modal show={show} onHide={handleClose} centered size="xl">
        <Modal.Header closeButton>
          <Modal.Title>
            {editId ? "Edit Scheme Category" : "Add Scheme Category"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="categoryName" className="mb-3">
              <Form.Label>Category Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter category name"
                value={categoryData.name}
                onChange={(e) =>
                  setCategoryData({ ...categoryData, name: e.target.value })
                }
                required
              />
            </Form.Group>

            <Form.Group controlId="categoryImage" className="mb-3">
              <Form.Label>Image</Form.Label>
              <Form.Control
                type="file"
                accept="image/*"
                onChange={handleImageChange}
              />
              {preview && (
                <img
                  src={preview}
                  alt="Preview"
                  style={{
                    width: "100px",
                    marginTop: "10px",
                    borderRadius: "8px",
                    border: "1px solid #ddd",
                  }}
                />
              )}
            </Form.Group>

            <Button
              variant="primary"
              type="submit"
              disabled={loading}
              className="w-100"
            >
              {loading
                ? "Saving..."
                : editId
                ? "Update Category"
                : "Add Category"}
            </Button>
          </Form>

          {/* Category List */}
          <div className="mt-4">
            <h5 className="mb-3">Scheme Categories</h5>
            <Table striped hover responsive>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Image</th>
                  <th>Name</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {categories.length > 0 ? (
                  categories.map((cat, index) => {
                    const relatedSchemes = getSchemesByCategory(cat.id);
                    return (
                      <React.Fragment key={cat.id}>
                        <tr>
                          <td>{index + 1}</td>
                          <td>
                            <img
                              src={cat.image}
                              alt={cat.name}
                              style={{ width: "60px", borderRadius: "6px" }}
                            />
                          </td>
                          <td>{cat.name}</td>
                          <td>
                            <Form.Check
                              type="switch"
                              id={`status-switch-${cat.id}`}
                              checked={cat.status || false}
                              onChange={() =>
                                handleStatusToggle(cat.id, cat.status)
                              }
                              label={cat.status ? "Active" : "Inactive"}
                              
                            />
                          </td>
                          <td>
                            <Button
                              className=" btn-sm"
                              
                              onClick={() => handleEdit(cat)}
                              variant="outline-secondary"
                            >
                              <FontAwesomeIcon
                                icon={faEdit}
                                className="fa-icon"
                              />
                            </Button>{" "}
                            <Button
                              variant="outline-danger"
                              size="sm"
                              onClick={() => handleDelete(cat.id)}
                            >
                              <FontAwesomeIcon
                                icon={faTrash}
                                className="fa-icon"
                              />
                            </Button>{" "}
                          </td>
                        </tr>

                        {/* Schemes List */}
                        <tr>
                          <td
                            colSpan="5"
                            style={{ padding: 0, border: "none" }}
                          >
                            <Collapse in={openCategory === cat.id}>
                              <div className="p-3 bg-light">
                                <h6 className="mb-2">
                                  Schemes under <b>{cat.name}</b>
                                </h6>
                                {relatedSchemes.length > 0 ? (
                                  <Table bordered size="sm">
                                    <thead>
                                      <tr>
                                        <th>#</th>
                                        <th>Scheme Name</th>
                                        <th>Amount</th>
                                        <th>Duration</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {relatedSchemes.map((scheme, i) => (
                                        <tr key={scheme.id}>
                                          <td>{i + 1}</td>
                                          <td>{scheme.name}</td>
                                          <td>₹{scheme.amount}</td>
                                          <td>{scheme.duration} months</td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </Table>
                                ) : (
                                  <div className="text-muted fst-italic">
                                    No schemes found for this category.
                                  </div>
                                )}
                              </div>
                            </Collapse>
                          </td>
                        </tr>
                      </React.Fragment>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center text-muted">
                      No categories found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default SchemeCategoryModal;
